exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CN8b_H-vp26NxjABwwT7a{white-space:nowrap;color:\"[theme:redDark, default:#a80000]\";font-weight:400}html[dir=ltr] .rK3aivbMQMOCkH0WcMu-q{margin-right:10px}html[dir=rtl] .rK3aivbMQMOCkH0WcMu-q{margin-left:10px}", ""]);

// exports
exports.locals = {
	"couponRow": "CN8b_H-vp26NxjABwwT7a",
	"icon": "rK3aivbMQMOCkH0WcMu-q"
};